module.exports = __webpack_public_path__ + "static/media/back-teal.ea313101.png";